<template>
  <div>
    <div v-if="isLoading" class="fixed inset-0 backdrop-blur-lg bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-black/50 bg-opacity-95 p-6  mx-36 rounded-lg shadow-lg flex flex-col items-center">
        <div class="animate-spin rounded-full h-16 w-16 border-t-4 border-orange-300 border-solid"></div>
        <p v-if="isHandling" class="mt-4 text-white text-lg">در حال انتقال...</p>
        <p v-else class="mt-4 text-white text-lg">در حال بارگزاری لیست...</p>
        <button
            @click="reloadPage"
            class="text-sm mt-4 bg-pink-600 text-white px-4 py-2 rounded hover:bg-pink-500 transition duration-200 "
        >
          در صورت ضعیف بودن اینترنت صفحه رو رفرش کنید
        </button>
      </div>
    </div>

    <div class="p-6 bg-gray-800/60 rounded-xl min-h-screen">
      <div class="flex flex-wrap gap-3 justify-between items-center mb-6">
        <h5 class="text-l font-bold text-gray-800 inline-block transition-all duration-500">
    <span
        class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 hover:animate-pulse ml-2">
      کمبود پردازش
    </span>
        </h5>
        <div class="flex gap-3 mr-3">
          <div class="flex items-center gap-1">
            <searchable-select v-model="filters.inventory_store" :options="stores"
                               placeholder="انبار"
                               class="w-32 backdrop-blur-xl z-40"
                               @change="fetchWithStore"
            ></searchable-select>

          </div>
        </div>
        <button
            type="button"
            @click="openMinimumInventoryModal"
            class="bg-purple-700 hover:bg-purple-600 text-white text-sm px-3 py-2 rounded-lg">
          تنظیم حداقل موجودی پردازش
        </button>
        <button
            @click="printPage"
            class="ml-auto bg-primary hover:bg-blue-900 text-white text-sm px-3 py-1 rounded-lg ">
           چاپ
        </button>

      </div>
      <div
          class="z-50 bg-gray-700 bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-lg p-3 mb-2 shadow-sm border border-gray-800">
        <div class="flex flex-wrap items-center gap-2">
          <div class="relative w-32">
            <input
                v-model="filters.name_search"
                placeholder="نام"
                class="px-2 py-1.5 bg-gray-800 text-white text-xs rounded-lg border w-full text-right"
                @keyup.enter="applyFilters"
            >
          </div>
          <div class="relative w-32">
            <input
                v-model="filters.sku"
                placeholder="SKU"
                class="px-2 py-1.5 bg-gray-800 text-white text-xs rounded-lg border w-full text-right"
                @keyup.enter="applyFilters"
            >
          </div>
          <div class="relative w-32">
            <input
                v-model="filters.id_in"
                placeholder="شناسه"
                class="px-2 py-1.5 bg-gray-800 text-white text-xs rounded-lg border w-full text-right"
                @keyup.enter="applyFilters"
            >
          </div>
          <div class="relative w-32">
            <searchable-select v-model="filters.brand_in" :options="brands"
                               placeholder="همه برندها"
                               class="w-32 backdrop-blur-xl z-40"
                               @change="applyFilters"
            ></searchable-select>
          </div>
          <div class="flex items-center gap-1">
            <span class="text-[10px] text-gray-300">حداقل موجودی</span>
            <input
                v-model.number="filters.minimum_inventory_min"
                type="number"
                placeholder="از"
                class="px-2 py-1.5 bg-gray-800 text-white text-xs rounded-lg border w-16 text-right"
                @keyup.enter="applyFilters"
            >
            <input
                v-model.number="filters.minimum_inventory_max"
                type="number"
                placeholder="تا"
                class="px-2 py-1.5 bg-gray-800 text-white text-xs rounded-lg border w-16 text-right"
                @keyup.enter="applyFilters"
            >
          </div>
          <div class="flex items-center gap-1">
            <span class="text-[10px] text-gray-300">موجودی پردازش</span>
            <input
                v-model.number="filters.inventory_min"
                type="number"
                placeholder="از"
                class="px-2 py-1.5 bg-gray-800 text-white text-xs rounded-lg border w-16 text-right"
                @keyup.enter="applyFilters"
            >
            <input
                v-model.number="filters.inventory_max"
                type="number"
                placeholder="تا"
                class="px-2 py-1.5 bg-gray-800 text-white text-xs rounded-lg border w-16 text-right"
                @keyup.enter="applyFilters"
            >
          </div>
          <div class="flex items-center gap-1">
            <span class="text-[10px] text-gray-300">موجودی کل</span>
            <input
                v-model.number="filters.total_inventory_min"
                type="number"
                placeholder="از"
                class="px-2 py-1.5 bg-gray-800 text-white text-xs rounded-lg border w-16 text-right"
                @keyup.enter="applyFilters"
            >
            <input
                v-model.number="filters.total_inventory_max"
                type="number"
                placeholder="تا"
                class="px-2 py-1.5 bg-gray-800 text-white text-xs rounded-lg border w-16 text-right"
                @keyup.enter="applyFilters"
            >
          </div>
          <div class="flex gap-1">
            <button
                @click="resetFilters"
                class="p-1.5 bg-gradient-to-r from-gray-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
                title="حذف فیلترها"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                   stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
              </svg>
            </button>

            <button
                @click="applyFilters"
                class="p-1.5 bg-gradient-to-r from-red-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
                title="اعمال فیلتر"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                   stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <v-dialog v-model="showMinimumInventoryModal" max-width="480" :persistent="savingMinimumInventory">
        <v-card dir="rtl" class="pa-5">
          <h2 id="minimum-inventory-title" class="text-lg font-bold mb-4">حداقل موجودی پردازش</h2>
          <p id="minimum-inventory-description" class="text-sm mb-4">
            این مقدار برای تمام ردیف‌های دارای محصول در انبارهایی که نام آن‌ها شامل «پردازش» است و حداقل موجودی آن‌ها صفر است، ثبت می‌شود؛ مستقل از فیلترهای صفحه. مقادیر غیرصفر تغییر نمی‌کنند.
          </p>
          <p v-if="loadingMinimumInventoryPreview" role="status" class="text-sm mb-4">در حال شمارش محصولات...</p>
          <p v-else-if="minimumInventoryPreview" role="status" class="text-sm mb-4">
            تعداد محصولات مشمول: <strong>{{ minimumInventoryPreview.product_count }}</strong>
            ({{ minimumInventoryPreview.inventory_count }} ردیف موجودی)
            <span class="block mt-1">تعداد نهایی ممکن است با تغییر هم‌زمان موجودی‌ها متفاوت باشد.</span>
          </p>
          <v-btn v-else text small @click="fetchMinimumInventoryPreview">تلاش مجدد برای شمارش</v-btn>
          <form @submit.prevent="saveMinimumInventory" aria-labelledby="minimum-inventory-title">
            <label for="packing-minimum-inventory" class="block text-sm mb-2">حداقل موجودی پردازش</label>
            <input
                id="packing-minimum-inventory"
                ref="minimumInventoryInput"
                v-model="minimumInventoryValue"
                type="number" min="1" max="2147483647" step="1" required
                :disabled="savingMinimumInventory"
                aria-describedby="minimum-inventory-description minimum-inventory-error"
                :aria-invalid="Boolean(minimumInventoryError)"
                class="w-full border border-gray-500 rounded-lg px-3 py-2 mb-3"
            >
            <p v-if="minimumInventoryError" id="minimum-inventory-error" role="alert" class="text-red-500 text-sm mb-3">
              {{ minimumInventoryError }}
            </p>
            <div class="flex justify-end gap-3 mt-4">
              <v-btn text type="button" :disabled="savingMinimumInventory" @click="showMinimumInventoryModal = false">انصراف</v-btn>
              <v-btn color="primary" type="submit" :loading="savingMinimumInventory"
                     :disabled="savingMinimumInventory || loadingMinimumInventoryPreview || !minimumInventoryPreview || minimumInventoryPreview.inventory_count === 0">ثبت</v-btn>
            </div>
          </form>
        </v-card>
      </v-dialog>
      <p v-if="minimumInventorySuccess" role="status" class="text-green-400 text-sm mb-3">
        {{ minimumInventorySuccess }}
      </p>

      <!-- Table -->
      <div
          id="section-to-print"
          class="z-10 bg-gray-700 bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-lg shadow-sm border border-gray-800 overflow-hidden">
        <div class="overflow-x-auto">
          <table class="min-w-full text-sm">
            <thead class="bg-gray-50 bg-opacity-70">
            <tr>
              <th class="p-3 items-center text-center text-[10px] text-white bg-gray-900">SKU</th>
              <th class="p-3 items-center text-center text-[10px] text-white bg-gray-900">لیبل</th>
              <th class="p-3 text-[10px] text-white bg-gray-900">محصول</th>
              <th class="p-3 text-[10px] text-white bg-gray-900">قیمت مصرف کننده</th>
              <th class="p-3 items-center text-center text-[8px] text-white bg-gray-900">نیاز به شارژ</th>
              <th class="p-3 items-center text-center text-[10px] text-white bg-gray-900">حداقل موجودی پردازش</th>
              <th class="p-3 items-center text-center text-[10px] text-white bg-gray-900">موجودی پردازش</th>
              <th class="p-3 items-center text-center text-[10px] text-white bg-gray-900">موجودی کل</th>
              <th class="p-3 items-center text-center text-[10px] text-white bg-gray-900">انتقال از انبار</th>
              <th class="p-3 items-center text-center text-[10px] text-white bg-gray-900">تعداد انتقال</th>
              <th class="p-3 items-center text-center text-[10px] text-white bg-gray-900"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="loading">
              <td colspan="6" class="p-4 text-center">
                <div class="flex justify-center items-center gap-2">
                  <svg class="animate-spin h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                       viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  در حال بارگذاری...
                </div>
              </td>
            </tr>
            <tr v-else-if="products.length === 0">
              <td colspan="6" class="p-4 text-center text-gray-500">
                محصولی یافت نشد
              </td>
            </tr>
            <tr
                v-for="product in products"
                :key="product.id"
                class="border-t border-gray-800 hover:bg-gray-900 transition-colors duration-200"
                :class="product.is_minimum? 'bg-rose-700/50 hover:bg-rose-700/70': ''"
            >
              <td class=" items-center text-center p-3 font-medium text-[12px] text-white">
                {{ product.sixteen_digit_code || ' بدون کد' }}
              </td>
              <td class=" items-center text-center p-3 font-medium text-[12px] text-white">
                <button
                    class=" items-center bg-white/10 rounded-lg  px-1.5 py-1 hover:bg-gray-50 text-center"
                    @click.stop="openLabelPrice(product.product_id, 'html')"
                >
                  <span> لیبل قیمت</span>
                </button>
                <button
                    class=" items-center bg-white/10 rounded-lg  px-1.5 py-1 hover:bg-gray-50 text-center mt-2"
                    @click.stop="openإBarcodePrice(product.product_id, 'html')"
                >
                  <span>  لیبل GTN </span>
                </button>
              </td>
              <td class="p-3" style="max-with: 150px">
                <div class="flex items-center gap-3">
                  <div class="relative" v-if="product.image">
                    <img
                        :src="img_source(product.image)"
                        class="w-16 h-16 rounded-lg object-cover border border-gray-200 shadow-sm"
                    >
                  </div>
                  <div
                      class="text-center pt-6 items-center text-[40px]  relative w-16 h-16 rounded-lg object-cover border border-gray-200 bg-gray-900/30 shadow-sm"
                      v-else
                  >
                    📦
                  </div>
                  <div>
                    <div class="text-[9px] font-medium text-white">{{ product.name }}</div>
                    <div class="text-[9px] text-gray-500 text-xs mt-1 flex items-center gap-1"
                         v-if="product.variation_of">
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24"
                           stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/>
                      </svg>
                      {{ product.variation_of.name }}
                    </div>
                  </div>
                </div>
              </td>
              <td class="p-3 text-white">
                <span v-if="product.regular_price > 0">
                  {{product.regular_price | toMoney(0)}}
                </span>
                <span v-else>
                  خارجی
                </span>
              </td>
              <td class="items-center text-center p-3 text-[13px] text-white">
                <v-icon v-if="product.is_minimum" color="red"> fa-check</v-icon>
              </td>
              <td class="items-center text-center p-3 text-[13px] text-white">
                <cleave-money currency-unit="عدد" label=" " v-model="product.minimum_inventory"> </cleave-money>
              </td>
              <td class="items-center text-center p-3 text-[13px] text-white">
                {{ product.store_inventory | toMoney }}
              </td>
              <td class="items-center text-center p-3 text-[13px] text-white">
                {{ product.in_store.inventory | toMoney }}
              </td>
              <td class="items-center text-center p-3 text-[13px] text-white">
                {{ product.in_store.name }}
              </td>
              <td class="items-center text-center p-3 text-[13px] text-white">
                <input
                    @input="validTransferQuantity(product)"
                    type="number"
                    v-model.number="product.transfer_quantity"
                    class="bg-blue-50/80 dark:bg-slate-800/70 w-full border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100
                                  px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-indigo-500
"
                />
              </td>
              <td class="items-center p-3">
                <button @click="handleDone(product)"
                        class="p-2 bg-cyan-800 text-white text-[12px] rounded-lg"
                        title="انتقال">
                  انتقال

                </button>
              </td>

            </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="p-4 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4">
          <div class="text-sm text-gray-600">
            نمایش {{ (currentPage - 1) * itemsPerPage + 1 }} تا
            {{ Math.min(currentPage * itemsPerPage, totalProducts) }} از
            {{ totalProducts }} محصول
          </div>
          <div class="flex gap-1">
            <button
                @click="prevPage"
                :disabled="currentPage === 1"
                class="p-2 border border-gray-200 rounded-lg bg-white bg-opacity-50 hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                :class="{ 'opacity-50 cursor-not-allowed': currentPage === 1 }"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                   stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
            </button>
            <button
                v-for="page in visiblePages"
                :key="page"
                @click="goToPage(page)"
                class="p-2 text-center border border-gray-200 rounded-full transition-colors duration-200"
                :class="{
              'bg-gradient-to-r from-blue-500/60 to-blue-600/50 text-white shadow-md': page === currentPage,
              'bg-white bg-opacity-50 hover:bg-gray-50': page !== currentPage,
              'cursor-default': page === '...'
            }"
                :disabled="page === '...'"
            >
              {{ page }}
            </button>
            <button
                @click="nextPage"
                :disabled="currentPage * itemsPerPage >= totalProducts"
                class="p-2 border border-gray-200 rounded-lg bg-white bg-opacity-50 hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                :class="{ 'opacity-50 cursor-not-allowed': currentPage * itemsPerPage >= totalProducts }"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                   stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
      <transition name="slide-fade">
        <div v-if="showNotification"
             class="fixed bottom-4 right-4 z-50 flex items-center p-4 w-[90%] max-w-xs text-gray-100 bg-gray-900 rounded-lg shadow-lg border border-gray-700">

          <div
              class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg text-green-400 bg-gray-800">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"/>
            </svg>
          </div>

          <div class="mr-3 text-sm font-normal pr-2">انتقال با موفقیت ثبت شد</div>

          <button @click="showNotification = false"
                  class="mr-auto text-gray-400 hover:text-white rounded-lg p-1.5 hover:bg-gray-800">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"/>
            </svg>
          </button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import PackingStoreHandle from "@/modules/store_handle/PackingStoreHandle";
import StoreSelect from "@/components/selects/StoreSelect";
import CleaveMoney from "@/components/mcomponents/cleave/Money";
import SearchableSelect from "@/components/selects/SearchableSelect";

export default {
  name: 'PackingInventory',
  components: {CleaveMoney, StoreSelect, PackingStoreHandle, SearchableSelect},
  data() {
    return {
      showNotification: false,
      showMinimumInventoryModal: false,
      minimumInventoryValue: 12,
      minimumInventoryPreview: null,
      loadingMinimumInventoryPreview: false,
      minimumInventoryError: '',
      minimumInventorySuccess: '',
      savingMinimumInventory: false,
      errorMessage: '',
      hasError: false,
      showQuickEdit: false,
      selectedProduct: null,
      selectedProductId: null,
      loading: false,
      isHandling: false,
      isLoading: false,

      products: [],
      totalProducts: 0,
      currentPage: 1,
      activePricing: [],
      itemsPerPage: 20,
      filters: {
        id_in: '',
        store: 1,
        inventory_store: null,
        name_search: '',
        sku: '',
        search_value: '',
        brand_in: '',
        minimum_inventory_min: '',
        minimum_inventory_max: '',
        inventory_min: '',
        inventory_max: '',
        total_inventory_min: '',
        total_inventory_max: '',
      },
      categories: [],
      brands: [],
      stores: [],
      currencies: [],
      productSelected: null,
      showProductStoreHandle: false
    }
  },
  computed: {
    visiblePages() {
      const totalPages = Math.ceil(this.totalProducts / this.itemsPerPage)
      const range = 1
      const pages = []

      pages.push(1)

      if (this.currentPage - range > 2) {
        pages.push('...')
      }

      for (let i = Math.max(2, this.currentPage - range); i <= Math.min(totalPages - 1, this.currentPage + range); i++) {
        pages.push(i)
      }

      if (this.currentPage + range < totalPages - 1) {
        pages.push('...')
      }

      if (totalPages > 1) {
        pages.push(totalPages)
      }

      return pages
    },
  },
  methods: {
    openMinimumInventoryModal() {
      this.minimumInventoryValue = 12
      this.minimumInventoryError = ''
      this.minimumInventorySuccess = ''
      this.showMinimumInventoryModal = true
      this.fetchMinimumInventoryPreview()
      this.$nextTick(() => {
        if (this.$refs.minimumInventoryInput) this.$refs.minimumInventoryInput.focus()
      })
    },
    fetchMinimumInventoryPreview() {
      if (this.loadingMinimumInventoryPreview) return
      this.minimumInventoryPreview = null
      this.minimumInventoryError = ''
      this.loadingMinimumInventoryPreview = true
      this.request({
        url: this.endpoint('store_handle/packingMinimumInventory'),
        method: 'get',
        success: (data) => {
          this.minimumInventoryPreview = data
          this.loadingMinimumInventoryPreview = false
        },
        error: () => {
          this.loadingMinimumInventoryPreview = false
          this.minimumInventoryError = 'شمارش محصولات انجام نشد. اتصال و دسترسی خود را بررسی کرده و دوباره تلاش کنید.'
        }
      })
    },
    saveMinimumInventory() {
      if (this.savingMinimumInventory || this.loadingMinimumInventoryPreview ||
          !this.minimumInventoryPreview || this.minimumInventoryPreview.inventory_count === 0) return
      const value = Number(this.minimumInventoryValue)
      if (!Number.isInteger(value) || value < 1 || value > 2147483647) {
        this.minimumInventoryError = 'یک عدد صحیح مثبت تا ۲۱۴۷۴۸۳۶۴۷ وارد کنید.'
        return
      }
      this.minimumInventoryError = ''
      this.savingMinimumInventory = true
      this.request({
        url: this.endpoint('store_handle/packingMinimumInventory'),
        method: 'post',
        data: { minimum_inventory: value },
        success: (data) => {
          this.savingMinimumInventory = false
          this.showMinimumInventoryModal = false
          this.minimumInventorySuccess = data.updated_count === 0
              ? 'ردیفی با شرایط موردنظر برای تغییر وجود نداشت.'
              : `حداقل موجودی پردازش برای ${data.updated_count} ردیف به ${data.minimum_inventory} تغییر کرد.`
          this.currentPage = 1
          this.fetchProducts()
        },
        error: (error) => {
          this.savingMinimumInventory = false
          const status = error.response && error.response.status
          this.minimumInventoryError = status === 401 || status === 403
              ? 'اجازه انجام این عملیات را ندارید. وضعیت ورود و دسترسی خود را بررسی کنید.'
              : status === 400
                  ? 'مقدار واردشده معتبر نیست. یک عدد صحیح مثبت وارد کنید.'
                  : 'نتیجه عملیات مشخص نیست. پیش از تلاش مجدد، فهرست را بررسی کنید.'
        }
      })
    },
    reloadPage() {
      window.location.reload();
    },
    openLabelPrice(productId, mode) {
      const baseUrl = this.endpoint(`product/priceLabel/${productId}?token=${this.token}`);
      const url = `${baseUrl}&mode=${mode}`;

      if (mode === 'html') {
        window.open(url, '_blank');
      } else {
        window.open(url, '_blank');
      }

    },
    openإBarcodePrice(productId, mode) {
      const baseUrl = this.endpoint(`product/priceLabelSku/${productId}?token=${this.token}`);
      const url = `${baseUrl}&mode=${mode}`;

      if (mode === 'html') {
        window.open(url, '_blank');
      } else {
        window.open(url, '_blank');
      }
    },

    fetchWithStore() {
      this.totalProducts = 0
      this.currentPage = 1
      this.activePricing = []
      this.itemsPerPage = 20
      this.fetchProducts()

    },
    validTransferQuantity(product) {
      if (product.transfer_quantity > product.in_store.inventory) {
        this.hasError = true;
        this.errorMessage = `موجودی انبار  ${product.in_store.inventory}.`;
        product.transfer_quantity = product.in_store.inventory
      } else {
        this.hasError = false;
        this.errorMessage = '';
      }

    },
    isActive(product) {
      return this.activePricing.some(p => p === product);
    },
    showNotificationMessage() {
      this.showNotification = true;
      setTimeout(() => {
        this.showNotification = false;
      }, 5000);
    },
    fetchBrands() {
      this.request({
        url: this.endpoint('api/brands'),
        method: 'get',
        success: (data) => {
          this.brands = data
        }
      })
    },
    fetchStores() {
      this.request({
        url: this.endpoint(`main/store`),
        method: "get",
        success: data => {
          this.stores = data || [];
        }
      })
    },
    printPage() {
      window.print()
    },
    handleTransfer(product) {
      this.$router.push(`/panel/inventoryTransfers?product=${product.product_id}&in_store=${product.in_store}`)
    },
    fetchProducts() {
      this.isLoading = true

      const params = {
        limit: this.itemsPerPage,
        offset: (this.currentPage - 1) * this.itemsPerPage,
        ...this.filters
      }

      Object.keys(params).forEach(key => {
        if (params[key] === '') {
          delete params[key]
        }
      })

      this.request({
        url: this.endpoint('store_handle/storeInventoryList'),
        method: 'get',
        params,
        success: (data) => {
          this.products = []
          for (let item of data.results) {
            this.products.push(
                {
                  product_id: item.product_id,
                  in_store: item.in_store,
                  image: item.image,
                  product: item.id,
                  minimum_inventory: item.minimum_inventory,
                  is_minimum: item.is_minimum,
                  sixteen_digit_code: item.sixteen_digit_code,
                  name: item.name,
                  variation_of: item.variation_of,
                  regular_price: item.regular_price,
                  product_type: item.product_type,
                  store_inventory: item.inventory,
                  total_inventory: item.total_inventory,
                  transfer_quantity: item.transfer_quantity,
                }
            )
          }
          this.totalProducts = data.count
          this.isLoading = false
        },
        error: () => {
          this.isLoading = false
        }
      })
    },

    applyFilters() {
      this.currentPage = 1
      this.fetchProducts()
    },

    resetFilters() {
      this.filters = {
        id_in: '',
        store: 1,
        name_search: '',
        sku: '',
        inventory_store: null,
        search_value: '',
        brand_in: '',
        minimum_inventory_min: '',
        minimum_inventory_max: '',
        inventory_min: '',
        inventory_max: '',
        total_inventory_min: '',
        total_inventory_max: '',
      }
      this.applyFilters()
    },

    refreshProducts() {
      this.fetchProducts()
    },
    handleDone(product) {
      this.isLoading = true
      this.isHandling = true
      this.request({
        url: this.endpoint('store_handle/inventoryTransferCreate'),
        method: 'post',
        data: {
          from_store_id: product.in_store.id,
          to_store_id: 1,
          minimum_inventory : product.minimum_inventory,
          quantity: product.transfer_quantity,
          product_id: product.product_id,
        },
        success: (data) => {
          this.isLoading = false
          this.fetchProducts()
          this.showNotificationMessage()

        },
        error: (data) => {
          this.isLoading = false
        }
      })
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.fetchProducts()
      }
    },

    nextPage() {
      if (this.currentPage * this.itemsPerPage < this.totalProducts) {
        this.currentPage++
        this.fetchProducts()
      }
    },

    goToPage(page) {
      if (page !== '...') {
        this.currentPage = page
        this.fetchProducts()
      }
    },
    productStoreHandle(product) {
      this.selectedProduct = product
      this.showProductStoreHandle = true

    },
    active(product) {
      const index = this.activePricing.indexOf(product);
      if (index > -1) {
        this.activePricing.splice(index, 1);
      } else {
        this.activePricing.push(product);
      }
    },
    calculate_discount(price, discount) {
      return price - (price / 100 * discount)
    },
    closeProductStoreHandle() {
      this.selectedProduct = null
      this.showProductStoreHandle = false
    },


  },
  mounted() {
    this.fetchBrands()
    this.fetchStores()
    this.fetchProducts()
  }
}
</script>

<style>
/* RTL support */
body {
  direction: rtl;
  text-align: right;
}

/* Glass morphism effect */
.glass {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

/* Neumorphism effect */
.neumorphism {
  border-radius: 16px;
  background: #f0f0f0;
  box-shadow: 8px 8px 16px #d9d9d9,
  -8px -8px 16px #ffffff;
}

/* Smooth transitions */
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.glass-card {
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.bg-secondary {
  background-color: #424242;
}

@media print {
  body * {
    visibility: hidden;
  }

  #section-to-print,
  #section-to-print * {
    visibility: visible;
  }

  #section-to-print {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
}
searchable-select {
  background: rgba(15, 23, 42, 0.8) !important;
  color: rgba(255, 255, 255, 0.9) !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
}

.searchable-select-dropdown {
  background: rgba(15, 23, 42, 0.95) !important;
  border: 1px solid rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(10px) !important;
}

/* items داخل dropdown */
.searchable-select-item {
  color: rgba(255, 255, 255, 0.9) !important;
}

.searchable-select-item:hover {
  background: rgba(99, 102, 241, 0.9) !important;
}

</style>
